import React from "react";

function SubmitForm({ onSubmit, iframeRef, uploadM, uploadImg }) {

  function getIframeM() { 
    if (iframeRef.current && iframeRef.current.contentWindow.M) {
      return iframeRef.current.contentWindow.M;
    }
    return null;
  }
  function getIframeBase64() { 
    if (iframeRef.current && iframeRef.current.contentWindow) {
      return iframeRef.current.contentWindow.getSceneBase64();
    }
    return null;
  }


  async function Submit(e) {
    e.preventDefault();

    const url = "https://script.google.com/macros/s/AKfycbyfwcBLi94zmfrYbi_wTvCFIdEcUoOaUq_PnyQcCVakHg8OYrmO0JG-w6yClZGYbjPQ/exec";
    const formEle = document.querySelector("form");
    const formData = new FormData(formEle);

    if (uploadImg) {
      const base64 = await getIframeBase64();
      console.log("base64", base64);
      formData.append("Image", base64)
    }

    if (uploadM) {
      const manifold = getIframeM();
      if (manifold) {
        formData.append("Manifold", JSON.stringify(manifold));
      }
    }

    fetch(url, {
      method: "POST",
      body: formData,
      mode: 'cors' // Ensure CORS is handled correctly
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("JESSE");
        console.log(data);
      })
      .catch((error) => {
        console.log("JESSE");
        console.log(error);
      });
    
    onSubmit();
  }

    return (
        <div className="modal">
            <div className="modal-content">
                <span className="close" onClick={onSubmit}>&times;</span>
                <h1 style={{ color: "white" }}>Contact Form</h1>
                <div>
                    <form className="form" onSubmit={Submit}>
                    <input placeholder="Name" name="Name" type="text" />
                    <input placeholder="Email" name="Email" type="text" />
                    <input type="submit" value="Submit" />
                    </form>
                </div>
            </div>
    </div>
    );
}

export default SubmitForm;
